<section class="minicart">
  <div class="minicart_total">
    <div class="free-shipping-amount">
      <img
        class="rocket-icon"
        alt="@@BENEFIT_ICON"
        [src]="'assets/images/home_benefits/rocket_green.svg' | staticFileHash"
        i18n-alt
      />
      @if (freeShippingValue - cartTotal > 0) {
        <span i18n="@@minicart.noFreeShipping"
          >Only <strong>{{ freeShippingCalculation() }}</strong> left to get free shipping</span
        >
      }
      @if (freeShippingValue - cartTotal <= 0) {
        <span i18n="@@minicart.freeShipping">Enjoy free shipping!</span>
      }
    </div>
    @if (products.length === 0) {
      <div class="text-center">
        <span i18n="@@EMPTY_CART">Empty cart</span>
      </div>
    }
    <div class="minicart_total-amount">
      <div i18n="@@minicart.subtotal">Subtotal:</div>
      <div data-testid="subtotal">{{ cartTotal | currency: storeCurrency : 'symbol' : '1.2-2' }}</div>
    </div>
    @if (products && products.length > 0) {
      <div class="minicart-buttons">
        <button
          type="button"
          class="btn btn-primary"
          data-gtmcategory="event_bin_action"
          data-gtmaction="event_checkout_now"
          i18n="@@minicart.checkoutNow"
          aria-label="@@minicart.checkoutNow"
          data-internal-id="mini-cart-button"
          (click)="goToCart(); gtmEvent($event)"
        >
          Checkout now
        </button>
      </div>
    }
    <div class="products_qty">
      <span>{{ cartCount }}</span>
      <span i18n="@@ITEM">{cartCount, plural, =1 {item} other {items}}</span>
    </div>
  </div>
  <div class="minicart-table">
    @for (product of products; track prodTracker($index, product)) {
      <app-minicart-item
        [productsTillCartFull]="productsTillCartFull"
        [product]="product"
        (updateCart)="onUpdateCart($event)"
        (removeFromCart)="onRemoveFromCart($event)"
      />
    }
  </div>
</section>
